<template>
    <svg
        id="LogoSvg"
        data-name="NEW VECTOR"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 100 1600 300"
        style="enable-background: new 0 100 1600 300"
        height="40"
        width="214"
    >
        <path
            class="cls-1"
            d="m324.43,287.64v70.12c0,4.5-2.54,7.11-6.94,7.11h-23.12c-4.4,0-6.94-2.6-6.94-7.11v-56.86c0-13.03-7.86-21.8-19.42-21.8s-19.89,8.77-19.89,21.8v56.86c0,4.5-2.54,7.11-6.94,7.11h-23.12c-4.4,0-6.94-2.6-6.94-7.11v-161.1c0-4.5,2.54-7.11,6.94-7.11h23.12c4.4,0,6.94,2.6,6.94,7.11v67.28h.92c3.7-12.32,17.35-20.37,34.22-20.37,24.74,0,41.15,17.54,41.15,44.07Z"
        />
        <path
            class="cls-2"
            d="m1457.3,302.34v4.41c0,4.63-3.24,9.1-7.99,9.1h-78.61c3.5,12.46,13.23,17.27,27.95,17.27,8.48,0,15.47-2.2,19.72-6.11,3.49-2.93,6.24-4.4,10.23-2.68l17.71,7.33c4.5,1.95,6.25,5.37,3.75,9.28-10.49,15.39-30.45,25.41-51.67,25.41-39.18,0-65.13-25.64-65.13-64s24.95-63.99,62.64-63.99,61.39,25.64,61.39,63.99Zm-86.6-10.25h48.91c-1.75-13.43-10.48-20.52-24.95-20.52-12.97,0-21.21,7.33-23.96,20.52Z"
        />
        <path
            class="cls-1"
            d="m855.32,302.51v4.41c0,4.63-3.24,9.1-7.99,9.1h-78.61c3.5,12.46,13.23,17.27,27.95,17.27,8.48,0,15.47-2.2,19.72-6.11,3.49-2.93,6.24-4.4,10.23-2.68l17.71,7.33c4.5,1.95,6.25,5.37,3.75,9.28-10.49,15.39-30.45,25.41-51.67,25.41-39.18,0-65.13-25.64-65.13-64s24.95-63.99,62.64-63.99,61.39,25.64,61.39,63.99Zm-86.6-10.25h48.91c-1.75-13.43-10.48-20.52-24.95-20.52-12.97,0-21.21,7.33-23.96,20.52Z"
        />
        <path
            class="cls-2"
            d="m982.05,195.71v17.38c0,4.72-2.54,7.46-6.94,7.46h-56.64l-.16,36.82h52.49c4.4,0,6.94,2.73,6.94,7.46v14.45c0,4.73-2.54,7.46-6.94,7.46h-52.49l.16,70.66c0,4.73-2.54,7.46-6.94,7.46h-25.42c-4.4,0-6.94-2.73-6.94-7.46v-161.7c0-4.73,2.54-7.46,6.94-7.46h89c4.4,0,6.94,2.73,6.94,7.46Z"
        />
        <path
            class="cls-2"
            d="m1004.8,220.14v-19.42c0-4.4,2.54-6.94,6.94-6.94h23.12c4.4,0,6.94,2.54,6.94,6.94v19.42c0,4.4-2.54,6.94-6.94,6.94h-23.12c-4.4,0-6.94-2.54-6.94-6.94Zm0,137.8v-112.83c0-4.4,2.54-6.94,6.94-6.94h23.12c4.4,0,6.94,2.54,6.94,6.94v112.83c0,4.4-2.54,6.94-6.94,6.94h-23.12c-4.4,0-6.94-2.54-6.94-6.94Z"
        />
        <path
            class="cls-1"
            d="m678.53,353.47v-158.7c0-6.86,2.5-10.82,6.81-10.82h22.7c4.32,0,6.81,3.96,6.81,10.82v158.7c0,6.86-2.5,10.82-6.81,10.82h-22.7c-4.32,0-6.81-3.96-6.81-10.82Z"
        />
        <g>
            <path
                class="cls-1"
                d="m483.02,241.54l17.63-.19c1.42-.02,2.56-1.17,2.56-2.59l.06-32.11c.98-3.91,3.76-5.87,8.32-5.87h24.64c1.43,0,2.59,1.16,2.59,2.59v35.6c0,1.43,1.16,2.59,2.59,2.59h112.81c1.69,0,2.92,1.58,2.51,3.22l-6.11,24.46c-.29,1.15-1.33,1.96-2.51,1.96h-106.7c-1.43,0-2.59,1.16-2.59,2.59v53.03c0,2.94.72,5.37,2.14,7.28,1.42,1.92,3.49,2.88,6.19,2.88,1.38,0,2.55-.14,3.49-.43.94-.28,1.75-.61,2.45-.98.69-.37,1.34-.7,1.95-.98.62-.29,1.32-.43,2.14-.43,1.15,0,2.06.26,2.76.79.69.54,1.4,1.37,2.14,2.51l6.89,18.12c.42,1.11.02,2.36-.94,3.05-3.71,2.67-5.59,3.47-10.97,5.09-6.12,1.83-12.44,2.76-18.97,2.76-6.04,0-11.35-.89-15.97-2.64s-8.49-4.23-11.63-7.46c-3.14-3.23-5.53-7.12-7.15-11.69-1.63-4.56-2.45-9.66-2.45-15.3v-55.6c0-1.43-1.16-2.59-2.59-2.59h-22.99l7.72-29.67Z"
            />
            <path
                class="cls-1"
                d="m620.88,271.22v55.62c0,2.94.72,5.37,2.14,7.28,1.42,1.92,3.49,2.88,6.19,2.88,1.38,0,2.55-.14,3.49-.43.94-.28,1.75-.61,2.45-.98.69-.37,1.34-.7,1.95-.98.62-.29,1.32-.43,2.14-.43,1.15,0,2.06.26,2.76.79.69.54,1.4,1.37,2.14,2.51l6.89,18.13c.42,1.1.02,2.35-.93,3.04-3.72,2.67-5.6,3.48-10.98,5.09-6.12,1.83-12.44,2.76-18.97,2.76-6.04,0-11.35-.89-15.97-2.64s-8.49-4.23-11.63-7.46c-3.14-3.23-5.53-7.12-7.15-11.69-1.63-4.56-2.45-9.66-2.45-15.3v-55.61c0-1.43-1.16-2.58-2.58-2.58h-23m7.72-29.67l17.64-.19c1.41-.02,2.55-1.16,2.55-2.58l.06-32.12c.98-3.91,3.76-5.87,8.32-5.87h24.65c1.43,0,2.58,1.16,2.58,2.58v38.2"
            />
        </g>
        <path
            class="cls-1"
            d="m430.8,343.81c1.31-2.32,2.41-4.85,3.2-7.61,0,9.36-7.61,19.8-12.68,24.38-1.1,1,.03,2.88,1.52,2.9,3.84.04,10.01.1,11.52.1h18.9c4.28,0,6.75-2.68,6.75-7.3v-107.09c0-4.63-2.47-7.3-6.75-7.3h-22.51c-4.28,0-6.75,2.68-6.75,7.3v58.41c0,13.39-7.65,22.38-19.35,22.38s-18.91-9-18.91-22.38v-58.41c0-4.63-2.47-7.3-6.75-7.3h-22.5c-4.27,0-6.75,2.68-6.75,7.3v72.04c0,27.26,15.98,45.27,40.06,45.27,4.6,0,8.68-.32,12.34-.87,5.36-.76,20.19-8.03,27.94-20.62l.73-1.2Z"
        />
        <path
            class="cls-2"
            d="m1511.44,249.04c-4.51,3.95-11.13,10.96-13.17,19.64,0-9.62,6.36-18.43,12.96-24.97.78-.77-.06-2.11-1.15-2.12-2.69-.01-6.9-.1-8.19-.1h-19.42c-4.4,0-6.75,1.3-6.75,6.04v109.84c0,4.75,2.54,7.49,6.94,7.49h23.12c4.4,0,6.94-2.74,6.94-7.49v-59.92c0-13.73,12.3-22.95,35.15-22.78l1.89-13.59,2.96-21.24c-20.36-.5-33.61,2.94-41.26,9.18Z"
        />
        <path
            class="cls-2"
            d="m1294.48,336.45c.5,8.91-7.6,19.36-13.47,25.88-.66.73.6,1.39,3.02,1.42s4.26.05,6.47.05h19.43c4.39,0,6.87-4.43,6.87-8.93v-160.78c0-4.5-2.55-7.09-6.94-7.09h-23.13c-4.39,0-6.93,2.6-6.93,7.09v55.57h0c-11.21-5.35-17.11-8.75-33.76-8.75-31.44,0-52.48,24.83-52.48,61.94s29.91,61.95,52.48,61.95c43.06,0,48.44-28.35,48.44-28.35Zm-40.39-6.97c-14.63,0-26.49-13.38-26.49-29.87s11.86-29.87,26.49-29.87,24.61,13.38,24.61,29.87-9.98,29.87-24.61,29.87Z"
        />
        <g>
            <ellipse class="cls-1" cx="68.29" cy="358.16" rx="4.82" ry="8.35" />
            <ellipse class="cls-1" cx="114.62" cy="358.31" rx="4.45" ry="8.19" />
            <ellipse class="cls-1" cx="19.49" cy="357.66" rx="5.63" ry="7.21" />
            <line class="cls-4" x1="47.39" y1="292.02" x2="47.39" y2="292.02" />
            <path
                class="cls-1"
                d="m165.79,195.81c12.54-2.03,30.45-45.01.52-44.68-81.52.89-164.81,32.49-150.51,64.28,15.59,34.67,23.26,32.4,42.85,32.92,13.8.37,91.62-.12,88.32,20.38-2.61,16.2-22.08,31.88-84.79,19.86-4.94-.88-7.34-1.28-10.23-1.22-10.08.2-14.73.85-27.44,4.67-13.1,5.2-19.68,5.26-21.78,19.97-.37,2.58-6.49,45.71.85,47.91,27,2.73,55.46-.26,55.46-.26h1.8s0-.05,0-.09c0-8.3,3.33-15.03,7.43-15.03s7.43,6.73,7.43,15.03c0,.05,0,.1,0,.16l31.21.09c0-.08-.01-.16-.01-.25,0-8.3,3.33-15.03,7.43-15.03s7.43,6.73,7.43,15.03c0,.11-.01.2-.02.31h2.23c5.23-.22,55.14-12.76,63.11-58.23,7.97-45.47-39.85-56.83-63.11-59.75-25.57-3.21-55.15-2.68-57.19-6.21-2.47-4.28,13.7-33.26,99-39.86ZM3.44,354.68c-2.14,0-1.36-4.77,0-6,2.73-2.46,9.26,6,9.26,6H3.44Zm39.15,1.05h-11.3s7.97-10.32,11.3-7.32c1.66,1.5,2.61,7.32,0,7.32Zm25.69-26.91c-.42,8.02-13.59,3.31-20.21,5.05-6.62,1.74-5.49,13.8-30.21,13.24-11.54-.26-14.67-7.12-14.67-7.12,0,0,.56-18.97,1.89-26.06.89-4.71.86-10.64,6.62-13.15,36.67-16.41,58.18-6.05,58.18-6.05,0,0-.98,22.02-1.61,34.1Z"
            />
            <path class="cls-3" d="m51.48,289.27s-5.01,26.61-4.83,47.77c0,.69-.65,4.41-.65,4.41" />
        </g>
        <path
            class="cls-2"
            d="m1095.44,262.95c-1.31,2.32-2.41,4.85-3.2,7.61,0-9.38,7.38-19.62,12.7-24.42,1.09-.98-.03-2.85-1.5-2.87-3.84-.04-10.04-.1-11.56-.1h-18.9c-4.28,0-6.75,2.68-6.75,7.3v107.09c0,4.63,2.47,7.3,6.75,7.3h22.51c4.28,0,6.75-2.68,6.75-7.3v-58.41c0-13.39,7.65-22.38,19.35-22.38,11.26,0,18.91,9,18.91,22.38v58.41c0,4.63,2.47,7.3,6.75,7.3h22.5c4.27,0,6.75-2.68,6.75-7.3v-72.04c0-27.26-15.98-45.27-40.06-45.27-4.56,0-8.6.31-12.24.86-.07.01-.13.02-.2.04-7.86,1.66-20.12,8.06-27.85,20.6l-.73,1.2Z"
        />
    </svg>
</template>

<style lang="postcss" scoped>
svg {
    .cls-1 {
        fill: #5fc2ee;
    }

    .cls-2 {
        fill: #4d97d1;
    }

    .cls-3 {
        stroke: #5fc2ee;
    }

    .cls-3,
    .cls-4 {
        fill: none;
        stroke-miterlimit: 10;
    }

    .cls-4 {
        stroke: #4d97d1;
    }
}
</style>
